import React, { useCallback, useState } from 'react';
import { PropTypes } from 'prop-types';
import clsx from 'clsx';

import { Box, Collapse, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as icons from 'mdi-material-ui';

const useStyles = makeStyles(theme => ({
    paper: {
        border: `1px solid ${theme.palette.grey[100]}`,
        borderRadius: 8,
        padding: theme.spacing(2),
        '&:not(last-child)': {
            marginBottom: theme.spacing(2),
        },
    },
    chevron: { display: 'flex', fontSize: 18 },
    icon: {
        fontSize: 24,
        transition: 'transform .2s',
        '&$open': {
            transform: 'rotate(90deg)',
        },
    },
    open: {},
    header: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    title: {
        fontWeight: 'bold',
        fontSize: 16,
    },
}));

const ExpandableList = props => {
    const { children, title, onCollapse, defaultOpen } = props;
    const classes = useStyles();

    const [expanded, setExpanded] = useState(defaultOpen || false);
    const handleToggleExpand = useCallback(() => {
        setExpanded(prevState => {
            onCollapse?.();
            return !prevState;
        });
    }, [onCollapse]);

    return (
        <Paper elevation={1} className={classes.paper}>
            <Box className={classes.header} onClick={handleToggleExpand}>
                <Typography color="primary" className={classes.chevron}>
                    <icons.ChevronRight
                        className={clsx({ [classes.icon]: true, [classes.open]: expanded })}
                    />
                </Typography>
                <Typography className={classes.title}>{title}</Typography>
            </Box>
            <Collapse in={expanded}>{children}</Collapse>
        </Paper>
    );
};

ExpandableList.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string.isRequired,
    onCollapse: PropTypes.func,
    defaultOpen: PropTypes.bool,
};

export default ExpandableList;
